import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '../../store'

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

//引入echarts
import * as echarts from 'echarts'

//引入svg
import '@/assets/icons/index.js'
import SvgIcon from '@/components/share/svg.vue'

import '@/assets/css/global.scss';

import Antd from 'ant-design-vue';

import * as Sentry from "@sentry/vue";

const app = createApp(App)

if(process.env.NODE_ENV === 'production'){
    let apname = '';
    let host = window.location.host;
    switch(host){
        case 'rayscloud.inteliway.cn:45081':
            apname = 'development';
            break;
        case 'rayscloud.inteliway.cn:9040':
            apname = 'rayscloud';
            break;
        case 'iws.inteliway.cn':
            apname = 'haiyueyun';
            break;
    }
    Sentry.init({
        app,
        dsn:'https://d1c5bb1341ded6fac4d8e71de7f67eea@iws.inteliway.cn:9999/2',
        sendClientReports:false,  // 不发送客户端报告
        maxBreadcrumbs: 1000,
        // maxValueLength: 1000000,  //发送到Sentry的事件的每个字符串属性在截断之前可以具有的最大字符数
        normalizeDepth: 10, 
        normalizeMaxBreadth: 1000,
        environment: apname,
        integrations: [
            Sentry.browserTracingIntegration({ 
                router, 
                instrumentPageLoad: false, 
            }),
            Sentry.replayIntegration({
                // Additional SDK configuration goes in here, for example:
                maskAllText: false,
                maskAllInputs:false,
                blockAllMedia: false,
                networkDetailAllowUrls: [
                    window.location.origin, 
                    /^https:\/\/rayscloud\.inteliway\.cn:45081\/.*$/,
                    /^https:\/\/rayscloud\.inteliway\.cn:9040\/.*$/,
                    /^https:\/\/iws\.inteliway\.cn(\/.*)?$/
                ],
                networkCaptureBodies: true,  // 捕获请求/响应体
                networkRequestHeaders: ["Cache-Control"],// 捕获所有请求头
                networkResponseHeaders: ["Referrer-Policy"], // 捕获所有响应头
                // 增加 Canvas 录制增强配置
                _experiments: {
                    slowClickTimeout: 3000, // 长点击检测
                    canvasMaxSnapshotDimension: 2048, // 最大截图尺寸
                    canvasFactor: 0.5, // 画质压缩比
                    canvasSharpness: 0.3 // 锐化参数
                }
            }),
            Sentry.replayCanvasIntegration({
                // 关键配置：自动捕获参数
                enableManualSnapshot: false, // 关闭手动模式
                initialSnapshotDelay: 500,   // 初始截图延迟（等待画布初始化）
                snapshotInterval: 500,       // 每500ms捕获一次（2 FPS）
                quality: 'low',              // 画质选择（low/medium/high）
                webGlContext: 'webgl',       // 明确指定上下文类型
                recordWebGLResources: true   // 记录WebGL资源
            }),
        ],

        tracesSampleRate: 1.0,
        tracePropagationTargets: [ "localhost", /^https:\/\/rayscloud\.inteliway\.cn:(45081|9040)\//, /^https:\/\/iws\.inteliway\.cn\//],
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    })
}


// 全局注册 ElCollapse 组件
app.use(ElementPlus).use(VXETable)
app.use(Antd)
app.use(router).use(store).component('svg-icon', SvgIcon);
app.mount('#app_iws')
app.config.globalProperties.$echarts = echarts;